import {keepPreviousData, queryOptions, useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

import {useToast} from "@/hooks/use-toast";
import * as apiClient from "@/lib/api";
import {ApiError} from "@/lib/api";
import {SendShortReviewSetting} from "@/modules/review-settings/types";
import {QUERY_KEY_SHORT_REVIEW_SETTING} from "@/utils/keys";


function fetchSendShortReviewSetting(): Promise<SendShortReviewSetting> {
  return apiClient.get(`/firm/config/send-short-repeat-review`)
}

export const sendShortReviewSettingQueryOptions = () =>
  queryOptions({
    queryKey: [QUERY_KEY_SHORT_REVIEW_SETTING],
    queryFn: fetchSendShortReviewSetting,
    placeholderData: keepPreviousData
  });

export const useSendShortReviewSetting = () => {
  return useQuery(sendShortReviewSettingQueryOptions())
}

export function updateSendShortReviewSetting(params: SendShortReviewSetting) {
  return apiClient.put('/firm/config/send-short-repeat-review', params)
}

export const useUpdateSendShortReviewSettingMutation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: updateSendShortReviewSetting,

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SHORT_REVIEW_SETTING] });
      toast({ description: "Setting updated successfully", variant: "mint" });
    },

    onError: (error: unknown) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SHORT_REVIEW_SETTING] });
      if (error instanceof ApiError && error.message) {
        toast({ description: error.message, variant: "red" });
        return;
      }

      toast({ description: "Something went wrong, please try again" });
    },
  });
}
